import { SavedCollectionsState } from "@/components/SavedCollectionsListing/redux/types";

const savedCollectionsInitialState: SavedCollectionsState = {
  savedArticles: [],
  savedVideos: [],
  currentCollection: "",
  loading: false,
  error: null,
};

export default savedCollectionsInitialState;
